import {
  DICTIONARY_LIST_PATH,
  ModulesDictionaries,
} from "./modules-dictionaries";
import { RouteObject } from "react-router-dom";
import { CURRENT_DICTIONARY_PATH, Dictionary } from "./dictionary";
import {
  DictionaryValueEdit,
  DICTIONARY_VALUE_EDIT_PATH,
} from "./dictionary-value-edit";

import {
  CreateDictionaryValue,
  DICTIONARY_VALUE_CREATE_PATH,
} from "./dictionary-create-value";
import { RestrictDictionaries } from "./access/restrict-dictionaries";

export const dictionariesRoutes: RouteObject[] = [
  {
    path: DICTIONARY_LIST_PATH,
    element: (
      <RestrictDictionaries>
        <ModulesDictionaries />
      </RestrictDictionaries>
    ),
  },
  {
    path: CURRENT_DICTIONARY_PATH,
    element: (
      <RestrictDictionaries>
        <Dictionary />
      </RestrictDictionaries>
    ),
  },
  {
    path: DICTIONARY_VALUE_EDIT_PATH,
    element: (
      <RestrictDictionaries>
        <DictionaryValueEdit />
      </RestrictDictionaries>
    ),
  },
  {
    path: DICTIONARY_VALUE_CREATE_PATH,
    element: (
      <RestrictDictionaries>
        <CreateDictionaryValue />
      </RestrictDictionaries>
    ),
  },
];
